/* eslint-disable func-names */
import { Logo } from '@components';
import { Stack, Box, Typography } from '@mui/material';
import BackgroundCircle from '@pages/SignupOrLogin/Circle';

export default function () {
  return (
    <Box sx={{
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    >
      <BackgroundCircle />
      <Stack sx={{
        position: 'relative',
        zIndex: 99,
      }}
      >
        <Logo />
        <Box sx={{ height: '30px' }} />
        <Typography variant="h3">Page Not Found</Typography>
      </Stack>
    </Box>
  );
}
